import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import gsap from 'gsap';
import $ from 'jquery';
import { CloseMobileIcon } from '../../assets/icons';
import { LogoDarkIcon } from '../../assets';

function MobileNav ({ menu, catalogMenu, productsBySectorMenu }) {

    useEffect(() => {
        let mobileMenuTimeline = gsap.timeline();

        mobileMenuTimeline.fromTo(
            ".mobile-nav",
            {},
            {
                y: 0,
                opacity: 1,
                duration: 0.5
            }
        );
    
        mobileMenuTimeline.fromTo(
            ".mobile-nav .nav__content >ul >li",
            {},
            {
                opacity: 1,
                delay: 0.5,
                stagger: 0.07,
                y: 0,
            }, "<"
        );
    
        mobileMenuTimeline.pause();
    
        // Event listeners for opening/closing the mobile menu
        const body = document.querySelector("body");
        const menuButtons = document.querySelectorAll(".mobile-menu-button");
        const menuButtonClose = document.querySelector(".close-mobile-m");
    
        const toggleClass = () => {
            if (body.classList.contains("nav-active")) {
                body.classList.remove("nav-active");
                mobileMenuTimeline.reverse();
            } else {
                body.classList.add("nav-active");
                mobileMenuTimeline.play();
            }
        };
    
        menuButtons.forEach(button => {
            button.addEventListener("click", toggleClass);
        });
    
        menuButtonClose.addEventListener("click", toggleClass);
    
        // Cleanup function
        return () => {
            menuButtons.forEach(button => {
                button.removeEventListener("click", toggleClass);
            });
        
            menuButtonClose.removeEventListener("click", toggleClass);
        };
    }, []);

    useEffect(() => {
        const aLinks = document.querySelectorAll('.mobile-nav .nav__content .menu-l > a');
    
        const toggleDropdown = (element, contentSelector) => {
            const $element = $(element); // Convert to jQuery object
            $element.toggleClass('opened');
            $element.find(contentSelector).slideToggle(300);
        };
    
        const handleAElementClick = (event) => {
            const aLink = event.currentTarget;
            const element = aLink.closest('.menu-l');
            toggleDropdown(element, '>.sub-menu');
        };
    
        aLinks.forEach(aLink => {
            aLink.addEventListener('click', handleAElementClick);
        });

        return () => {
            aLinks.forEach(aLink => {
                aLink.removeEventListener('click', handleAElementClick);
            });
        };
    }, []);

    return (
        <div className="mobile-nav">
            <div className="nav__content">
                <div className="head">
                    <div className="main">
                        <div className="logo">
                            <a href="/"><LogoDarkIcon /></a>
                        </div>
                        <div className="close-mobile-m">
                            <CloseMobileIcon />
                        </div>
                    </div>
                </div>
                <ul>
                    {menu.map((item) => {
                        if (item.menu_link) {
                            return (
                                <li key={item.id}><a href={item.menu_link}>{item.menu_name}</a></li>
                            );
                        } else {
                            if (item.key === "resources") {
                                return (
                                    <li key={item.id} className="menu-l">
                                        <a>{item.menu_name}</a>
                                        <ul className="sub-menu">
                                            {item.children.map((child) => (
                                                <li key={child.key}><a href={child.menu_link}>{child.menu_name}</a></li>
                                            ))}
                                        </ul>
                                    </li>
                                );
                            } else {
                                return (
                                    <li className="menu-l" key={item.id}>
                                        <a>{item.menu_name}</a>
                                        <ul className="sub-menu">
                                            {item.key === "catalog" ? (
                                                catalogMenu.map((child) => (
                                                    <li key={child.category_id} className="menu-l">
                                                        <a>{child.label_name}</a>
                                                        <ul className="sub-menu">
                                                            {child.children.map((subChild) => (
                                                                <li key={subChild.category_id}>
                                                                    <a href={subChild.menu_link}>
                                                                        {subChild.label_name}
                                                                    </a>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </li>
                                                ))) : (
                                                productsBySectorMenu.map((child) => (
                                                    <li key={child.category_id} className="menu-l">
                                                        <a>{child.label_name}</a>
                                                        <ul className="sub-menu">
                                                            {child.children.map((subChild) => (
                                                                <li key={subChild.menu_link}>
                                                                    <a href={subChild.menu_link}>
                                                                        {subChild.label_name}
                                                                    </a>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </li>
                                                ))
                                            )
                                            }
                                        </ul>
                                    </li>
                                );
                            }
                        }
                    })}
                </ul>
            </div>
        </div>
    );
};

export default MobileNav;
